<div class="casino-promo-banner-container" *ngIf="promotionsBanner" [ngStyle]="{ 'background-color': styles?.containerBgColor }">
    <div class="icon" [ngClass]="styles.iconType" [style.color]="styles.textColor"></div>
    <a href="promotionsBanner?.promotionsCTA?.url" class="casino-promo-bannerUrl" (click)="onClick($event)">
        <div class="promo-banner-link">
            <h1 class="promo-banner-text" [style.color]="styles.textColor" [textContent]="promoCount"></h1>
            <div class="theme-right" *ngIf="promotionsBanner?.promotionsCTA?.url" [style.color]="styles.rightArrowColor"></div>
        </div>
    </a>
    <!-- <div class="theme-ex" (click)="onCloseBanner($event)"></div> -->
</div>
